module.exports = {"title":"GoGoVan - 404","404_title":"Oops!","404_body":"We can’t find the page you’re looking for.","404_sub":"","404_links_title":"Here are some helpful links instead:","404_links_button_link_title":"TAKE ME HOME"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/404/locale.json
// module id = 477
// module chunks = 0 1 2 3 4 5